import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateConversionService {

  constructor() { }

  convertToRelativeTime(dateString: string): string {
    const currentDate = new Date();
    const pastDate = new Date(dateString);
    const timeDifference = currentDate.getTime() - pastDate.getTime();

    // Convert milliseconds to months
    const monthsDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24 * 30));

    if (monthsDifference === 0) {
      return 'Less than a month ago';
    } else if (monthsDifference === 1) {
      return '1 month ago';
    } else {
      return monthsDifference + ' months ago';
    }
  }
}